import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    table: {
      marginTop: 40,
      '& table': {
        borderRadius: 15,
        overflow: 'hidden',
        marginBottom: 30,
      },
      '& thead': {
        background: '#14171A',
        borderRadius: '15px 15px 0px 0px',
      },
      '& thead th': {
        color: '#fff',
        borderBottom: 'none',
      },
      '& thead tr > *': {
        padding: theme.spacing(0.5, 5),
      },
      '& tbody tr > *': {
        padding: theme.spacing(0.5, 5),
      },
      '& tbody tr:nth-of-type(odd) ': {
        background: '#fff',
        cursor: 'pointer',
      },
      '& tbody tr:nth-of-type(even)': {
        background: '#F5F8FA',
        cursor: 'pointer',
      },
      '& td': {
        borderBottom: 'none',
      },
    },
    '.MuiDialog-paperWidthLg': {
      '& div': {
        padding: 0,
      },
    },
  }),
);

export default useStyles;
